import { IconName } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { ConnectorType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/enums/ocpi-protocol-enums';

interface GenericConnectorType {
  name: string;
  icon: IconName;
}

export const ConnectorTypeMap: Record<ConnectorType, string> = {
  [ConnectorType.CHADEMO]: 'CHADEMO',
  [ConnectorType.DOMESTIC_A]: 'DOMESTIC_X',
  [ConnectorType.DOMESTIC_B]: 'DOMESTIC_X',
  [ConnectorType.DOMESTIC_C]: 'DOMESTIC_X',
  [ConnectorType.DOMESTIC_D]: 'DOMESTIC_X',
  [ConnectorType.DOMESTIC_E]: 'DOMESTIC_E',
  [ConnectorType.DOMESTIC_F]: 'DOMESTIC_F',
  [ConnectorType.DOMESTIC_G]: 'DOMESTIC_X',
  [ConnectorType.DOMESTIC_H]: 'DOMESTIC_X',
  [ConnectorType.DOMESTIC_I]: 'DOMESTIC_X',
  [ConnectorType.DOMESTIC_J]: 'DOMESTIC_X',
  [ConnectorType.DOMESTIC_K]: 'DOMESTIC_X',
  [ConnectorType.DOMESTIC_L]: 'DOMESTIC_X',
  [ConnectorType.IEC_62196_T1]: 'IEC_62196_T1',
  [ConnectorType.IEC_62196_T1_COMBO]: 'IEC_62196_T1_COMBO',
  [ConnectorType.IEC_62196_T2]: 'IEC_62196_T2',
  [ConnectorType.IEC_62196_T2_COMBO]: 'IEC_62196_T2_COMBO',
  [ConnectorType.IEC_62196_T3A]: 'OTHER',
  [ConnectorType.IEC_62196_T3C]: 'OTHER',
  [ConnectorType.TESLA_S]: 'OTHER',
  [ConnectorType.TESLA_R]: 'OTHER',
  [ConnectorType.IEC_60309_2_single_16]: 'OTHER',
  [ConnectorType.IEC_60309_2_three_16]: 'OTHER',
  [ConnectorType.IEC_60309_2_three_32]: 'OTHER',
  [ConnectorType.IEC_60309_2_three_64]: 'OTHER',
};

export const GenericConnectorTypeEnum: Record<string, GenericConnectorType> = {
  CHADEMO: { name: 'CHADEMO', icon: 'power-chademo' },
  DOMESTIC_E: { name: 'DOMESTIC_E', icon: 'power-type-e' },
  DOMESTIC_F: { name: 'DOMESTIC_F', icon: 'power-domestic' },
  DOMESTIC_X: { name: 'DOMESTIC_#', icon: 'power-domestic' },
  IEC_62196_T1: { name: 'IEC_62196_T1', icon: 'power-type-1' },
  IEC_62196_T1_COMBO: {
    name: 'IEC_62196_T1_COMBO',
    icon: 'power-type-1-combo-ccs',
  },
  IEC_62196_T2: { name: 'IEC_62196_T2', icon: 'power-type-2' },
  IEC_62196_T2_COMBO: {
    name: 'IEC_62196_T2_COMBO',
    icon: 'power-type-2-combo-ccs',
  },
  OTHER: { name: 'OTHER', icon: 'lightning-02' },
};

export const mapTypeToGenericConnectorType = (
  type: ConnectorType,
): GenericConnectorType =>
  GenericConnectorTypeEnum[ConnectorTypeMap[type]] ?? {
    name: 'UNKNOWN',
    icon: 'x-close',
  };
